import SignIn from "../../../components/sign-in/SignIn";

const SignInPage = () => {
    return(
        <SignIn />
    )
}

export default SignInPage;